var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecocornerhomepageAboutBoardDsu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 418.06 398.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        opacity: .16;\n      }\n\n      .cls-3 {\n        fill: #e6e7eb;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.05,165.32h238.24c1.69,0,3.05,2.73,3.05,6.09v220.9c0,3.37-1.37,6.09-3.05,6.09H3.05c-1.69,0-3.05-2.73-3.05-6.09v-220.9c0-3.37,1.37-6.09,3.05-6.09Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "deco"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9719",
    "data-name": "Group 9719",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27730",
    "data-name": "Path 27730",
    className: "cls-3",
    d: "M219.52,398.41c-65.43-.54-126.63-32.46-164.53-85.8-15.84-23.15-26.78-49.29-32.16-76.82C2.57,127.68,73.8,23.62,181.91,3.37c5.8-1.09,11.64-1.91,17.51-2.48,9.52-3.09,19.74,2.13,22.83,11.65,3.09,9.52-2.13,19.74-11.65,22.83-2.56.83-5.28,1.08-7.95.73C112.81,46.11,48.1,127.06,58.12,216.89c5.69,51.02,34.98,96.41,79.13,122.61,11.53,7.36,24.1,12.97,37.27,16.65,87.97,24.26,178.95-27.39,203.21-115.35,2.3-8.34,3.94-16.85,4.91-25.44.31-9.51,8.28-16.96,17.78-16.65.07,0,.13,0,.2,0h0c10.01.39,17.81,8.82,17.42,18.83-.01.34-.04.67-.07,1.01-10.3,101.68-95.88,179.23-198.46,179.85h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27731",
    "data-name": "Path 27731",
    className: "cls-3",
    d: "M180.88,237.09c-21.2-21.29-21.12-55.74.17-76.94,21.29-21.2,55.74-21.12,76.94.17,21.14,21.23,21.13,55.55,0,76.78-21.02,21.29-55.32,21.51-76.61.48-.17-.16-.33-.33-.49-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27732",
    "data-name": "Path 27732",
    className: "cls-3",
    d: "M214.33,325.44c-65.04-2.7-117.56-53.89-121.72-118.6-4.16-64.72,41.38-122.1,105.54-132.97,9.89-1.69,19.28,4.96,20.96,14.85.14.8.22,1.62.25,2.43l.64.64c-.25,8.52-6.39,15.71-14.77,17.28-44.8,7.07-77.46,46.18-76.42,91.53,2.16,48.01,40.69,86.39,88.71,88.35,45.35,1.16,84.59-31.37,91.85-76.16,2.02-8.65,9.75-14.75,18.63-14.72,9.51-.32,17.48,7.14,17.79,16.65.05,1.5-.1,3.01-.44,4.48-10.33,63.39-66.62,109.04-131.03,106.24Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecocornerhomepageAboutBoardDsu);
export default __webpack_public_path__ + "static/media/Deco corner homepage _ About Board DSU_.cc9093a7081641f04ea8f0f8c759a446.svg";
export { ForwardRef as ReactComponent };